import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';

export const getShipmentProductHazmatAPI = () => {
  return axiosInstance.request({
    url: `${API.SHIPMENT}/GetProductHazmat`,
    method: 'get',
  });
};

export type ShipmentProductHazmatResponse = {
  disabled: boolean;
  group: null;
  selected: boolean;
  text: 'Yes' | 'No'; // Yes, No
  value: 'y' | 'n'; // Y, N
}[];

export const fetchShipmentProductHazmat = async (): Promise<ShipmentProductHazmatResponse> => {
  const response: AxiosResponse<ShipmentProductHazmatResponse> = await getShipmentProductHazmatAPI();
  return response.data;
};
